import React, { useEffect, useState } from "react";
import { Table, Button, Container, Form, Modal, Dropdown, Row, Col, FormCheck } from "react-bootstrap";
import { PencilSquare, Trash, Check, X } from "react-bootstrap-icons";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// ------------ Page Imports ---------------

import "../../../App.css";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { formatToInputDate } from "../../../Utils/DateUtlis";
import { companyGet, DesignationGet, teamGet, employeeGet, employeePost, employeeEdit, getDormitoryDetails } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";
import {getCompanyShortForm} from "../../../Utils/CommonUtils"

const AllEmployees = () => {
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [formData, setFormData] = useState({
    company_id: '',
    emp_id: '',
    emp_name: '',
    nationality: '',
    design_id: '',
    NRIC_WP: '',
    WP_expiary_date: null,
    passport_no: '',
    contact_no: '',
    FIN_No: '',
    FIN_ISSUE_DATE: null,
    FIN_EXPIARY_DATE: null,
    blk_unit: '',
    is_dormitory: 0,
    dormitory_id: '',
    team_id: '',
    designation: '',
    company: '',
    team: ''
  });

  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    emp_id: null,
    emp_name: '',
    nationality: '',
    design_id: null,
    NRIC_WP: null,
    WP_expiary_date: null,
    passport_no: '',
    contact_no: null,
    FIN_No: '',
    FIN_ISSUE_DATE: null,
    FIN_EXPIARY_DATE: null,
    blk_unit: null,
    is_dormitory: 0,
    dormitory_id: null,
    team_id: null,
    designation: null,
    company_id: null,
    team_id: null
  });
  const [company, setCompany] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [teams, setTeams] = useState([]);
  const [dormitory, setDormitory] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loadingCompany, setLoadingComapany] = useState(false);


  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setCompany(companies);
          setLoadingComapany(true)
          console.log(`API Data ${JSON.stringify(company)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    const fetchDesignation = async () => {
      try {
        const data = await DesignationGet();
        if (data) {
          const mapedDesignations = data.map(i => ({
            id: i._id,
            name: i.name,
          }));
          setDesignations(mapedDesignations)
          console.log("Desiginations", designations);

          // setIsLoading(false);
          // console.log(`API Data ${JSON.stringify(apiData)}`);  // Under Production         
        } else {
          console.log('No Designation data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }

    }

    const fetchTeam = async () => {
      try {
        const data = await teamGet();
        if (data) {
          const team = data.results.map(i => ({
            id: i.team_id,
            name: i.team_name,
          }));
          setTeams(team)
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }

    const fetchDormitory = async () => {
      try {
        const data = await getDormitoryDetails();
        console.log('Dormitory API Results: ', data.result);

        if (data.result) {
          const place = data.result.map(i => ({
            _id: i._id,
            name: i.name,
            Area: i.Area,
            PIN: i.PIN,
          }))
          setDormitory(place);
          console.log('Dormitory Details: ', place);
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Dormitory: ', errorMessage || err);
        alert(errorMessage)
      }
      console.log('SetDormitory: ', dormitory);
    }
    fetchTeam();
    fetchDesignation();
    fetchCompany();
    fetchDormitory();
  }, [])

  const onEmployeedetails = async (id) => {
    try {
      const employees = await employeeGet(id);
      console.log("Employee data from API", employees);

      if (employees && employees.result) {
        const emp = employees.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          nationality: i.nationality,
          passport_no: i.passport_no,
          contact_no: i.contact_no,
          design_id: i.design_id,
          NRIC_WP: i.NRIC_WP,
          WP_expiary_date: i.WP_expiary_date,
          FIN_ISSUE_DATE: i.FIN_ISSUE_DATE,
          FIN_EXPIARY_DATE: i.FIN_EXPIARY_DATE,
          blk_unit: i.blk_unit,
          is_dormitory: i.is_dormitory,
          dormitory_id: i.dormitory_id,
          company_id: i.company_id,
          team_id: i.team_id,
          designation: i.designation,
          FIN_No: i.FIN_No,
          designation: i.designation,
          company: i.company,
          team: i.team
        }));
        setApiData(emp);
        console.log(`API Data : ${JSON.stringify(apiData)}`);

        setIsLoading(false)
      } else {
        setIsLoading(true)
      }

    } catch (err) {
      setIsLoading(true)
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(`Inside the form data`);

    try {
      const response = await employeePost(formData);
      console.log(`Response Data outside if: ${JSON.stringify(response)}`);

      if (response) {
        <div className="alert" role="alert">
          New Employee Created..
        </div>
        console.log(`Response Data inside if: ${JSON.stringify(response)}`);

        // window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
    setShowAddModal(false)
  }

  const handleClose = () => setShowAddModal(false);
  const handleEditClose = () => setShowEditModal(false);
  const handleShow = () => setShowAddModal(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleDateChange = (date, fieldName) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: date
    }));
  };

  const handleEditDateChange = (date, fieldName) => {
    setEditFormData(prev => ({
      ...prev,
      [fieldName]: date
    }));
  };

  const handleNumberInput = (e) => {
    const { name, value } = e.target;
    // Only allow numbers
    if (/^\d*$/.test(value)) {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleEditNumberInput = (e) => {
    const { name, value } = e.target;
    // Only allow numbers
    if (/^\d*$/.test(value)) {
      setEditFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };





  const handleEditFormChange = (event) => {
    const { name, value } = event.target;
    console.log(`Edit Name: ${name}`);
    console.log(`Edit Value: ${value}`);

    setEditFormData({
      ...editFormData,
      [name]: value
    });
  };


  const handleEdit = (editEmployee) => {
    setShowEditModal(true)
    console.log(`Selected Data : ${JSON.stringify(editEmployee)}`);
    setEditingId(editEmployee.emp_id);
    console.log(`Selected ID ${editingId}`);
    setEditFormData({
      emp_id: editEmployee.emp_id,
      emp_name: editEmployee.emp_name,
      nationality: editEmployee.nationality,
      design_id: editEmployee.design_id,
      NRIC_WP: editEmployee.NRIC_WP,
      WP_expiary_date: editEmployee.WP_expiary_date ? new Date(editEmployee.WP_expiary_date) : null,
      passport_no: editEmployee.passport_no,
      contact_no: editEmployee.contact_no,
      FIN_No: editEmployee.FIN_No,
      FIN_ISSUE_DATE: editEmployee.FIN_ISSUE_DATE ? new Date(editEmployee.FIN_ISSUE_DATE) : null,
      FIN_EXPIARY_DATE: editEmployee.FIN_EXPIARY_DATE ? new Date(editEmployee.FIN_EXPIARY_DATE) : null,
      blk_unit: editEmployee.blk_unit,
      is_dormitory: editEmployee.is_dormitory,
      dormitory_id: editEmployee.dormitory_id,
      team_id: editEmployee.team_id,
      designation: editEmployee.designation,
      company_id: editEmployee.company_id,
      team_id: editEmployee.team_id
    });
  }

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    console.log(`handlesubmit Edit`);
    try {
      const response = await employeeEdit(editFormData, editingId);
      if (response) {
        <div className="alert" role="alert">
          Employee Updated Successfully...
        </div>
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
    setShowEditModal(false);
  }
  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader
          title="Employees"
          showButtons={true}
        />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Employee Details
          <div className="d-flex flex-column align-items-end">
            <Button variant="primary" className="d-flex align-items-center mb-2" onClick={() => setShowAddModal(true)}>
              Create+
            </Button>
            <Dropdown onSelect={(eventKey) => {
              console.log("Selected Event Key:", eventKey);
              const selected = company.find(c => c.id == String(eventKey));
              console.log("Event Key:", eventKey);
              console.log("Company List:", company);
              console.log("Found Company: ", selected.id);
              let callID = selected.id;
              console.log(`Call ID : ${callID}`);

              setSelectedCompany(selected);
              console.log("Dropdown Selected Company: ", selectedCompany);

              onEmployeedetails(callID);
            }}>
              <Dropdown.Toggle variant="outline-secondary" id="company-dropdown">
                {selectedCompany ? selectedCompany.name : "Select Company"}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {!loadingCompany ? (
                  <Dropdown.Item disabled>Loading...</Dropdown.Item>
                ) : (
                  company.map(com => (
                    <Dropdown.Item key={com.id} eventKey={com.id} active={selectedCompany?.id === com.id}>
                      {com.name}
                    </Dropdown.Item>
                  ))
                )}
                {console.log(selectedCompany)
                }
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </h4>
        {isLoading ? <div class="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span class="sr-only">No Data to show</span>
          </div>
        </div> :
          <div style={{ overflow: 'auto' }}>
            <Table striped bordered hover responsive="sm" size="sm">
              <thead>
                <tr>
                  <th className="fs-12">Employee ID</th>
                  <th className="fs-12">Name</th>
                  <th className="fs-12">Nationality</th>
                  <th className="fs-12">Passport Number</th>
                  <th className="fs-12">Contact Number</th>
                  <th className="fs-12">FIN Number</th>
                  <th className="fs-12">Desigination</th>
                  <th className="fs-12">Company</th>
                  <th className="fs-12">Team</th>
                  <th className="fs-12">Actions</th>
                </tr>
              </thead>
              <tbody>
                {apiData.map((empData, i) => (
                  <tr key={empData.emp_id}>
                    <td className="fs-12">
                      {empData.emp_id}
                    </td>
                    <td className="fs-12">
                      {empData.emp_name}
                    </td>
                    <td className="fs-12">
                      {empData.nationality}
                    </td>
                    <td className="fs-12">
                      {empData.passport_no}
                    </td>
                    <td className="fs-12">
                      {empData.contact_no}
                    </td>
                    <td className="fs-12">
                      {empData.FIN_No}
                    </td>
                    <td className="fs-12">
                      {empData.designation}
                    </td>
                    <td className="fs-12">
                      {getCompanyShortForm(empData.company)}
                    </td>
                    <td className="fs-12">
                      {empData.team}
                    </td>
                    <td className="fs-12">
                      <Button variant="outline-primary" size="sm" onClick={() => handleEdit(empData)}>
                        <PencilSquare />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        }
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Add New Employee</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="company_id">
                    <Form.Label>Organization Name *</Form.Label>
                    <Form.Select
                      name="company_id"
                      value={formData.company_id}
                      onChange={handleChange}
                      required
                      style={{ height: '38px' }}
                    >
                      <option value="">Select Organization</option>
                      {company.map(org => (
                        <option key={org.id} value={org.id}>{org.name}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="emp_id">
                    <Form.Label>Emp ID *</Form.Label>
                    <Form.Control
                      type="text"
                      name="emp_id"
                      value={formData.emp_id}
                      onChange={handleChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="emp_name">
                    <Form.Label>Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="emp_name"
                      value={formData.emp_name}
                      onChange={handleChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="nationality">
                    <Form.Label>Nationality *</Form.Label>
                    <Form.Control
                      type="text"
                      name="nationality"
                      value={formData.nationality}
                      onChange={handleChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="design_id">
                    <Form.Label>Designation *</Form.Label>
                    <Form.Select
                      name="design_id"
                      value={formData.design_id}
                      onChange={handleChange}
                      required
                      style={{ height: '38px' }}
                    >
                      <option value="">Select Designation</option>
                      {designations.map(desig => (
                        <option key={desig.id} value={desig.id}>{desig.name}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="NRIC_WP">
                    <Form.Label>NRIC/WP *</Form.Label>
                    <Form.Control
                      type="text"
                      name="NRIC_WP"
                      value={formData.NRIC_WP}
                      onChange={handleChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                <Form.Label>Passport Expiry Date *</Form.Label>
                  <Form.Group controlId="WP_expiary_date">                  
                    <DatePicker
                      selected={formData.WP_expiary_date}
                      onChange={(date) => handleDateChange(date, 'WP_expiary_date')}
                      minDate={new Date()}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="passport_no">
                    <Form.Label>Passport Number *</Form.Label>
                    <Form.Control
                      type="text"
                      name="passport_no"
                      value={formData.passport_no}
                      onChange={handleChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="contact_no">
                    <Form.Label>Contact No *</Form.Label>
                    <Form.Control
                      type="text"
                      name="contact_no"
                      value={formData.contact_no}
                      onChange={handleNumberInput}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="FIN_No">
                    <Form.Label>FIN NO</Form.Label>
                    <Form.Control
                      type="text"
                      name="FIN_No"
                      value={formData.FIN_No}
                      onChange={handleChange}
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                 <Form.Label>FIN Issue Date</Form.Label>
                  <Form.Group controlId="FIN_ISSUE_DATE">
                   
                    <DatePicker
                      selected={formData.FIN_ISSUE_DATE}
                      onChange={(date) => handleDateChange(date, 'FIN_ISSUE_DATE')}
                      maxDate={new Date()}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Label>FIN Expiry Date</Form.Label>
                  <Form.Group controlId="FIN_EXPIARY_DATE">
                    <DatePicker
                      selected={formData.FIN_EXPIARY_DATE}
                      onChange={(date) => handleDateChange(date, 'FIN_EXPIARY_DATE')}
                      minDate={new Date()}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Form.Group controlId="is_dormitory">
                  <Form.Label>Dormitory</Form.Label>
                  <div className="d-flex align-items-center" style={{ height: '38px' }}>
                    <Form.Check
                      inline
                      label="Yes"
                      type="radio"
                      name="is_dormitory"
                      value="1"
                      checked={formData.is_dormitory === '1'}
                      onChange={handleChange}
                      className="me-2"
                    />
                    <Form.Check
                      inline
                      label="No"
                      type="radio"
                      name="is_dormitory"
                      value="0"
                      checked={formData.is_dormitory === '0'}
                      onChange={handleChange}
                    />
                  </div>
                </Form.Group>
              </Row>
              {formData.is_dormitory === '1' && (
                <Row className="mb-3 g-2 align-items-center">
                  <Col md={6} style={{marginBottom:'25px'}}>
                   <Form.Label >BLK Unit</Form.Label>
                    <Form.Group controlId="blk_unit">
                      <Form.Control
                        type="text"
                        name="blk_unit"
                        value={formData.blk_unit}
                        onChange={handleChange}
                        style={{ height: '38px' }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Row className="mb-3 g-2 align-items-center">
                      <Form.Group className="mb-3" controlId="dormitory_id">
                        <Form.Label>Dormitory Name</Form.Label>
                        <Form.Select
                          name="dormitory_id"
                          value={formData.dormitory_id}
                          onChange={handleChange}
                          style={{ height: '38px' }}
                        >
                          <option value=''>Select Dormitory</option>
                          {dormitory.map(dor => (
                            <option key={dor._id} value={dor._id}>{dor.name}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Row>

                  </Col>
                </Row>
              )
              }
              <Form.Group className="mb-3" controlId="team_id">
                <Form.Label>Team</Form.Label>
                <Form.Select
                  name="team_id"
                  value={formData.team_id}
                  onChange={handleChange}
                  style={{ height: '38px' }}
                >
                  <option value="">Select Team</option>
                  {teams.map(team => (
                    <option key={team.id} value={team.id}>{team.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="warning" onClick={handleClose}>
                Close
              </Button>
              <Button variant="secondary" type="submit">
                Save
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        {/* Edit Modal  */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title> Edit Employee Details</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleEditSubmit}>
            <Modal.Body>
              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="company_id">
                    <Form.Label>Organization Name *</Form.Label>
                    <Form.Select
                      name="company_id"
                      value={editFormData.company_id}
                      onChange={handleEditFormChange}
                      required
                      style={{ height: '38px' }}
                    >
                      {/* <option value="">Select Organization</option> */}
                      {company.map(org => (
                        <option key={org.id} value={org.id}>{org.name}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="emp_id">
                    <Form.Label>Emp ID *</Form.Label>
                    <Form.Control
                      type="text"
                      name="emp_id"
                      value={editFormData.emp_id}
                      onChange={handleEditFormChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="emp_name">
                    <Form.Label>Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="emp_name"
                      value={editFormData.emp_name}
                      onChange={handleEditFormChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="nationality">
                    <Form.Label>Nationality *</Form.Label>
                    <Form.Control
                      type="text"
                      name="nationality"
                      value={editFormData.nationality}
                      onChange={handleEditFormChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="design_id">
                    <Form.Label>Designation *</Form.Label>
                    <Form.Select
                      name="design_id"
                      value={editFormData.design_id}
                      onChange={handleEditFormChange}
                      required
                      style={{ height: '38px' }}
                    >
                      {/* <option value="">Select Designation</option> */}
                      {designations.map(desig => (
                        <option key={desig.id} value={desig.id}>{desig.name}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="NRIC_WP">
                    <Form.Label>NRIC/WP *</Form.Label>
                    <Form.Control
                      type="text"
                      name="NRIC_WP"
                      value={editFormData.NRIC_WP}
                      onChange={handleEditFormChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                   <Form.Label>Passport Expiry Date *</Form.Label>
                  <Form.Group controlId="WP_expiary_date">
                    <DatePicker
                      selected={editFormData.WP_expiary_date}
                      onChange={(date) => handleEditDateChange(date, 'WP_expiary_date')}
                      minDate={new Date()}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="passport_no">
                    <Form.Label>Passport Number *</Form.Label>
                    <Form.Control
                      type="text"
                      name="passport_no"
                      value={editFormData.passport_no}
                      onChange={handleEditFormChange}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="contact_no">
                    <Form.Label>Contact No *</Form.Label>
                    <Form.Control
                      type="text"
                      name="contact_no"
                      value={editFormData.contact_no}
                      onChange={handleEditNumberInput}
                      required
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                 <Form.Label>FIN NO</Form.Label>
                  <Form.Group controlId="FIN_No">
                   
                    <Form.Control
                      type="text"
                      name="FIN_No"
                      value={editFormData.FIN_No}
                      onChange={handleEditFormChange}
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                    <Form.Label>FIN Issue Date</Form.Label>
                  <Form.Group controlId="FIN_ISSUE_DATE">
                    <DatePicker
                      selected={editFormData.FIN_ISSUE_DATE}
                      onChange={(date) => handleEditDateChange(date, 'FIN_ISSUE_DATE')}
                      maxDate={new Date()}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                 <Form.Label>FIN Expiry Date</Form.Label>
                  <Form.Group controlId="FIN_EXPIARY_DATE">
                   
                    <DatePicker
                      selected={editFormData.FIN_EXPIARY_DATE}
                      onChange={(date) => handleEditDateChange(date, 'FIN_EXPIARY_DATE')}
                      minDate={new Date()}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 g-2 align-items-center">
                <Form.Group controlId="is_dormitory">
                  <Form.Label>Dormitory</Form.Label>
                  <div className="d-flex align-items-center" style={{ height: '38px' }}>
                    <Form.Check
                      inline
                      label="Yes"
                      type="radio"
                      name="is_dormitory"
                      value="1"
                      checked={editFormData.is_dormitory === 1}
                      onChange={handleEditFormChange}
                      className="me-2"
                    />
                    <Form.Check
                      inline
                      label="No"
                      type="radio"
                      name="is_dormitory"
                      value="0"
                      checked={editFormData.is_dormitory === 0}
                      onChange={handleEditFormChange}
                    />
                  </div>
                </Form.Group>
              </Row>
              <Row className="mb-3 g-2 align-items-center">
                <Col md={6}>
                  <Form.Group controlId="blk_unit" style={{marginBottom:'25px'}}>
                    <Form.Label>BLK Unit</Form.Label>
                    <Form.Control
                      type="text"
                      name="blk_unit"
                      value={editFormData.blk_unit}
                      onChange={handleEditFormChange}
                      style={{ height: '38px' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  {editFormData.is_dormitory === 1 && (
                    <Row className="mb-3 g-2 align-items-center">
                      <Form.Group className="mb-3" controlId="dormitory_id">
                        <Form.Label>Dormitory Name</Form.Label>
                        <Form.Select
                          name="dormitory_id"
                          value={editFormData.dormitory_id}
                          onChange={handleEditFormChange}
                          style={{ height: '38px' }}
                        >
                          <option value=''>Select Dormitory</option>
                          {dormitory.map(dor => (
                            <option key={dor._id} value={dor._id}>{dor.name}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Row>
                  )}
                </Col>
              </Row>
              <Form.Group className="mb-3" controlId="team_id">
                <Form.Label>Team</Form.Label>
                <Form.Select
                  name="team_id"
                  value={editFormData.team_id}
                  onChange={handleEditFormChange}
                  style={{ height: '38px' }}
                >
                  {/* <option value="">Select Team</option> */}
                  {teams.map(team => (
                    <option key={team.id} value={team.id}>{team.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="warning" onClick={handleEditClose}>
                Close
              </Button>
              <Button variant="secondary" type="submit">
                Edit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </Container>
    </div>
  )
};

export default AllEmployees;